import store from '../vuex/store';

const Current = {};

/**
 * Current plugin
 *
 * @param Vue
 * @param options
 */
Current.install = function(Vue, options)
{
    // register global methods
    Vue.current = store.state.current;

    // register instance methods
    Vue.prototype.$current = store.state.current;
};

export default Current;



// WEBPACK FOOTER //
// ./src/js/plugins/current.js